import { render, staticRenderFns } from "./contributeForm.vue?vue&type=template&id=272c8064&scoped=true&"
import script from "./contributeForm.vue?vue&type=script&lang=js&"
export * from "./contributeForm.vue?vue&type=script&lang=js&"
import style0 from "./contributeForm.vue?vue&type=style&index=0&id=272c8064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c8064",
  null
  
)

export default component.exports